export default {
    stickerList: {},
    stickers: [],
    stickerItems: {},
}